// extracted by mini-css-extract-plugin
export default {"row":"DisplayNameForm_row__dceuu","error":"DisplayNameForm_error__9eVYw","button":"DisplayNameForm_button__hvv09"};